import { useTranslation } from "react-i18next";
import Input from "src/components/form/Input";
import { TaskFormOptions } from "src/components/forms/TaskForm";
import Form from "src/components/forms/TaskForm/Form";
import GalleryForm from "src/components/forms/TaskForm/steps/GalleryForm";
import useTaskForm from "src/hooks/api/tasks/useTaskForm";
import useTaskScheme from "src/hooks/schemes/useTaskScheme";

const Descriptionform = ({ hideButtons }: TaskFormOptions) => {
	const { t } = useTranslation("forms", {
		keyPrefix: "description-task-form",
	});
	const { task, actions } = useTaskForm();
	const scheme = useTaskScheme();

	return (
		<Form
			{...{ hideButtons }}
			title={t("title")}
			onSubmit={async () => {
				actions.updateCurrent(1);
			}}
			value={{
				title: task?.title,
				description: task.description,
			}}
			schema={() => ({
				title: scheme.title,
				description: scheme.description,
			})}
			nextDisabled={!(task.title && task.description)}
		>
			{(getInputProps) => {
				return (
					<>
						<Input
							label={t("task-title")}
							name="title"
							{...getInputProps("title")}
						/>
						<Input
							label={t("description.label")}
							help={t("description.help")}
							placeholder={t("description.placeholder")}
							multiline
							name="description"
							{...getInputProps("description")}
						/>
						<GalleryForm />
					</>
				);
			}}
		</Form>
	);
};

export default Descriptionform;
